import React, { useState, useEffect } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { Button, Col, Form, Row, } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import Flex from 'components/common/Flex';
import { typehome, monthslist } from 'config'


const NewVilla = () => {
    const [valueContacts, setValueContactsId] = React.useState(null);
    const [valueOTA, setValueOTA] = React.useState(null);
    const [valueType, setValueType] = React.useState(null);
    const [valuePer, setValuePer] = React.useState(null);
    const [validated, setValidated] = React.useState(false);
    const [formd, setFrom] = React.useState({ show_parter: true });
    const [l, setL] = React.useState(false);
    const [clients, setClients] = React.useState([]);
    const [valueOwner, setValueOwner] = React.useState(null);
    const [prices, setPrices] = React.useState([]);
    const [services, setServices] = React.useState([]);
    const [servicesList, setServicesList] = React.useState([]);
    const [valueEquipment, setValueEquipment] = React.useState(null);
    const [equipements, setEquipements] = React.useState([]);

    const navigate = useNavigate();


    const loadList = () => {
        // get list clients and format
        firebase.firestore().collection('equiments').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                const dr = { value: d.id, label: d.data()?.title }
                s.push(dr)
            })
            setEquipements(s);

        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })

        firebase.firestore().collection('services').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                const dr = { value: d.id, label: d.data()?.title }
                s.push(dr)
            })
            setServicesList(s);

        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })
    }


    const getClients = () => {
        // get list clients and format
        firebase.firestore().collection('crm').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                let e = '';
                let pre = d.data()?.email?.split(',') || []
                pre.forEach((s) => {
                    e += `${s}, `;
                })
                const dr = { value: d.id, label: `${d.data()?.lastName} ${d.data()?.firstName}`, email: e }
                if (d.data()?.delete) { }
                else {
                    s.push(dr)
                }
            })
            setClients(s);

        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })

    }

    useEffect(() => {
        getClients()
        loadList();
    }, [])



    const handleChange = e => {
        let d = { ...formd };
        d[e.target.name] = e.target.value;
        if (e.target.name === 'show_parter') {
            d[e.target.name] = e.target.checked;
        }
        setFrom(d);
    };


    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === false) {
            toast.warning("Veuillez remplir les champs obligatoire")
            return;
        }

        if (l) {
            return;
        }

        var t = { ...formd }
        t._update_At = new Date();
        t._create_At = new Date();
        t.gallery = []
        t.files = []
        t.group = null
        t.fhsId = formd?.fhsId || null
        // t.calendarId = calendarId?.fhsId || null
        // t.priceStart = {
        //     per : valuePer, 
        //     price : Number(formd.price)
        // } 
        t.ownerId = formd.ownerId.value;
        t.localisation = {
            lat: formd.lat,
            long: formd.long
        }
        setValidated(true);
        setL(true);
        delete t.price;
        delete t.lat;
        delete t.long;
        try {
            firebase.firestore().collection('properties').add(t).then((doc) => {
                console.log("Document successfully written!");
                toast.success("Propriété créer avec succès");
                navigate('/villa/edit/' + doc.id)
            }).catch((error) => {
                setL(false);
                var errorMessage = error.message;
                toast.error(errorMessage);
            })
        } catch (error) {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        }
    };

    return (
        <FalconComponentCard>
            <FalconComponentCard.Header title={`Création de la propriété`} light={false} noPreview={true} />
            <FalconComponentCard.Body >
                <Form noValidate validated={validated} onSubmit={handleSubmit}>

                    <Row className="mb-3">
                        <Form.Group as={Col} md="4" controlId="nameHouse">
                            <Form.Label>Nom de la propriété</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                value={formd.nameHouse}
                                name="nameHouse"
                                onChange={handleChange}
                                placeholder="Nom de la propriété ..."
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="5" controlId="villa">
                            <Form.Label>Propriétaire</Form.Label>
                            <Select
                                closeMenuOnSelect={false}
                                required
                                options={clients}
                                placeholder='Choisir le propriétaire...'
                                classNamePrefix="react-select"
                                value={valueOwner}
                                onChange={value => {
                                    setValueOwner(value)
                                    let d = formd;
                                    d['ownerId'] = value;
                                    setFrom(d);
                                }}

                            />
                        </Form.Group>
                        <Form.Group as={Col} md="3">
                            <Form.Label>Espace partenaire</Form.Label>
                            <Form.Check
                                type="switch"
                                name="show_parter"
                                onChange={handleChange}
                                label="Afficher pour les partenaires"
                                checked={formd.show_parter}
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="8" controlId="fhsId">
                            <Form.Label>Identifiant interne FHS</Form.Label>
                            <Form.Control
                                type="text"
                                value={formd.fhsId}
                                name="fhsId"
                                onChange={handleChange}
                                placeholder="Demander l'identifiant de cette villa au développeur si elle existe..."
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="adresse">
                            <Form.Label>Adresse</Form.Label>
                            <Form.Control
                                type="text"
                                value={formd.adresse}
                                name="adresse"
                                onChange={handleChange}
                                placeholder="Adresse ..."
                            />
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="city">
                            <Form.Label>Ville</Form.Label>
                            <Form.Control
                                type="text"
                                value={formd.city}
                                name="city"
                                onChange={handleChange}
                                placeholder="Ville ..."
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="2" controlId="zipcode">
                            <Form.Label>Code postale</Form.Label>
                            <Form.Control
                                minlength="5"
                                type="text"
                                value={formd.zipcode}
                                name="zipcode"
                                onChange={handleChange}
                                placeholder="Code postale ..."
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="10" controlId="complement">
                            <Form.Label>Complément d'adresse</Form.Label>
                            <Form.Control
                                type="text"
                                value={formd.complement}
                                name="complement"
                                onChange={handleChange}
                                placeholder="Complément d'adresse ..."
                            />
                        </Form.Group>



                        <Form.Group as={Col} md="10" controlId="quatier">
                            <Form.Label>Quartier</Form.Label>
                            <Form.Control
                                type="text"
                                value={formd?.quartier}
                                name="quartier"
                                onChange={handleChange}
                                placeholder="Quartier de la location ..."
                            />
                        </Form.Group>


                        <Form.Group as={Col} md="2" controlId="m2">
                            <Form.Label>m2 (terrain)</Form.Label>
                            <Form.Control
                                type="number"
                                value={formd.m2}
                                name="m2"
                                onChange={handleChange}
                                placeholder="Surface en m2 ..."
                            />
                        </Form.Group>


                        <Form.Group as={Col} md="2" controlId="m2">
                            <Form.Label>m2 (habitable)</Form.Label>
                            <Form.Control
                                type="number"
                                value={formd.m2habitable}
                                name="m2habitable"
                                onChange={handleChange}
                                placeholder="Surface en m2 ..."
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="2" controlId="nbRooms">
                            <Form.Label>Nombre de chambres</Form.Label>
                            <Form.Control
                                type="number"
                                value={formd.nbRooms}
                                name="nbRooms"
                                onChange={handleChange}
                                placeholder="Nombre de chambres ..."
                            />
                        </Form.Group>


                        <Form.Group as={Col} md="2" controlId="nbBath">
                            <Form.Label>Nombre de Salle d'eau</Form.Label>
                            <Form.Control
                                type="number"
                                value={formd.nbBath}
                                name="nbBath"
                                onChange={handleChange}
                                placeholder="Nombre de Salle de bain ..."
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="2" controlId="maxGuest">
                            <Form.Label>Nbr d'invité max</Form.Label>
                            <Form.Control
                                type="number"
                                value={formd.maxGuest}
                                name="maxGuest"
                                onChange={handleChange}
                                placeholder="Inviter max..."
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="3" controlId="type">
                            <Form.Label>Type de bien</Form.Label>
                            <Select
                                closeMenuOnSelect={false}
                                required
                                options={typehome}
                                placeholder='Choisir...'
                                classNamePrefix="react-select"
                                value={valueType}
                                onChange={value => {
                                    setValueType(value)
                                    let d = formd;
                                    d['type'] = value;
                                    setFrom(d);

                                }}
                            />
                        </Form.Group>



                        <Form.Group as={Col} md="3" controlId="exposition">
                            <Form.Label>Exposition</Form.Label>
                            <Form.Control
                                type="text"
                                value={formd.exposition}
                                name="exposition"
                                onChange={handleChange}
                                placeholder="Sud, Est ..."
                            />
                        </Form.Group>

                        <Form.Group as={Col} md="7" controlId="distance">
                            <Form.Label>DISTANCE DE LA LOCATION par rapport aux principaux équipements et centres d’intérêt (km)</Form.Label>
                            <Form.Control
                                type="text"
                                value={formd.distance}
                                name="distance"
                                onChange={handleChange}
                                placeholder="3 km"
                            />
                        </Form.Group>




                        <Form.Group as={Col} md="3" controlId="vue">
                            <Form.Label>Vue</Form.Label>
                            <Form.Control
                                type="text"
                                value={formd.vue}
                                name="vue"
                                onChange={handleChange}
                                placeholder="Dégagée"
                            />
                        </Form.Group>

                        {/* <Form.Group as={Col} md="3" controlId="eauxusees">
                    <Form.Label>Eaux usées</Form.Label>
                    <Form.Control  
                        type="text"
                        value={formd.eauxusees}
                        name="eauxusees"
                        onChange={handleChange}
                        placeholder="Tout à l'égout" 
                    /> 
                </Form.Group> 

                <Form.Group as={Col} md="3" controlId="eauchaude">
                    <Form.Label>Eau chaude</Form.Label>
                    <Form.Control  
                        type="text"
                        value={formd.eauchaude}
                        name="eauchaude"
                        onChange={handleChange}
                        placeholder="Chauffe-eau" 
                    /> 
                </Form.Group>

                <Form.Group as={Col} md="3" controlId="chauffage_info">
                    <Form.Label>Chauffage</Form.Label>
                    <Form.Control  
                        type="text"
                        value={formd.chauffage_info}
                        name="chauffage_info"
                        onChange={handleChange}
                        placeholder="Electrique Climatisation Individuel" 
                    /> 
                </Form.Group> 

                <Form.Group as={Col} md="3" controlId="style">
                    <Form.Label>Style</Form.Label>
                    <Form.Control  
                        type="text"
                        value={formd.style}
                        name="style"
                        onChange={handleChange}
                        placeholder="CONTEMPORAIN" 
                    /> 
                </Form.Group>

                <Form.Group as={Col} md="3" controlId="contructIn">
                    <Form.Label>Construit en</Form.Label>
                    <Form.Control  
                        type="text"
                        value={formd.contructIn}
                        name="contructIn"
                        onChange={handleChange}
                        placeholder="2016" 
                    /> 
                </Form.Group>

                <Form.Group as={Col} md="3" controlId="etage">
                    <Form.Label>Étage</Form.Label>
                    <Form.Control  
                        type="text"
                        value={formd.etage}
                        name="etage"
                        onChange={handleChange}
                        placeholder="1er/1" 
                    /> 
                </Form.Group> 
                <Form.Group as={Col} md="3" controlId="etat">
                    <Form.Label>État</Form.Label>
                    <Form.Control  
                        type="text"
                        value={formd.etat}
                        name="etat"
                        onChange={handleChange}
                        placeholder="Neuf" 
                    /> 
                </Form.Group>

                <Form.Group as={Col} md="3" controlId="standing">
                    <Form.Label>Standing</Form.Label>
                    <Form.Control  
                        type="text"
                        value={formd.standing}
                        name="standing"
                        onChange={handleChange}
                        placeholder="Luxe" 
                    /> 
                </Form.Group> */}


                        <hr style={{ marginTop: 10 }} />

                        <Row className="mb-3">
                            <Form.Label>Tarifications</Form.Label>
                            {
                                prices.map((price, index) => {
                                    return (<Row className="mb-3">
                                        <Form.Group as={Col} md="4" className="mb-3">
                                            <Form.Label>Mois</Form.Label>
                                            <Select
                                                required
                                                isMulti
                                                closeMenuOnSelect={false}
                                                options={monthslist}
                                                placeholder='Choisir...'
                                                classNamePrefix="react-select"
                                                value={price?.months}
                                                onChange={(value) => {
                                                    let o = [...prices];
                                                    let m = { ...price };
                                                    m.months = value
                                                    o[index] = m;
                                                    setPrices(o);
                                                    let d = { ...formd };
                                                    d['prices'] = o;
                                                    setFrom(d);
                                                }}
                                            />
                                        </Form.Group>

                                        <Form.Group as={Col} md="2" controlId="price">
                                            <Form.Label>Prix</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={price?.price}
                                                name={`pricePrice_${index}`}
                                                onChange={(e) => {
                                                    let o = [...prices];
                                                    let m = { ...price };
                                                    m.price = e.target.value
                                                    o[index] = m;
                                                    setPrices(o);
                                                    let d = { ...formd };
                                                    d['prices'] = o;
                                                    setFrom(d);
                                                }}
                                                placeholder="Prix ..."
                                            />
                                        </Form.Group>


                                        <Form.Group as={Col} md="3" controlId="pricePer">
                                            <Form.Label>Par</Form.Label>
                                            <Select
                                                required
                                                options={[
                                                    { value: 'week', label: 'Semaine' },
                                                    { value: 'month', label: 'Mois' },
                                                ]}
                                                placeholder='Choisir...'
                                                classNamePrefix="react-select"
                                                value={price?.per}
                                                onChange={(value) => {
                                                    let o = [...prices];
                                                    let m = { ...price };
                                                    m.per = value
                                                    o[index] = m;
                                                    setPrices(o);
                                                    let d = { ...formd };
                                                    d['prices'] = o;
                                                    setFrom(d);
                                                }}
                                            />
                                        </Form.Group>

                                        <IconButton as={Col} md="1" onClick={() => {
                                            let arr = prices;
                                            arr.splice(index, 1);
                                            setPrices(arr);
                                            let d = { ...formd };
                                            d['prices'] = arr;
                                            setFrom(d);
                                        }}
                                            variant="falcon-danger"
                                            size="sm"
                                            icon="trash"
                                            transform="shrink-3"
                                            className='me-2'
                                            style={{ width: 60, height: 25, marginTop: 35 }}
                                        >
                                        </IconButton>
                                    </Row>)
                                })
                            }

                            <div>
                                <Flex
                                    alignItems="center"
                                    className="mb-4 text-primary cursor-pointer fs-0"
                                    onClick={() => {
                                        let o = [...prices];
                                        if (((o[o.length - 1]?.months?.length > 0  || o[o.length - 1]?.periodType.value !== 'month') && o[o.length - 1]?.price?.trim() !== "") || o.length === 0) {
                                            o.push({ months: [], price: "", per: null });
                                            setPrices(o);
                                        }
                                    }}
                                >
                                    <span className="circle-dashed">
                                        <FontAwesomeIcon icon="plus" />
                                    </span>
                                    <span className="ms-3">Ajouter un nouveau tarif</span>
                                </Flex>
                            </div>




                        </Row>

                        <hr style={{ marginTop: 10 }} />


                        <Row className="mb-3">
                            <Form.Label>Services</Form.Label>
                            {
                                services.map((service, index) => {
                                    return (<Row className="mb-3">



                                        <Form.Group as={Col} md="3" controlId="pricePer">
                                            <Form.Label>Service</Form.Label>
                                            <Select
                                                required
                                                options={
                                                    servicesList
                                                }
                                                placeholder='Choisir...'
                                                classNamePrefix="react-select"
                                                value={service?.service}
                                                onChange={(value) => {
                                                    let o = [...services];
                                                    let m = { ...service };
                                                    m.service = value
                                                    o[index] = m;
                                                    setServices(o);
                                                    let d = { ...formd };
                                                    d['services'] = o;
                                                    setFrom(d);
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md="3" className="mb-3">
                                            <Form.Label>Titre</Form.Label>
                                            <Form.Control
                                                name={`serviceTitle_${index}`}
                                                placeholder="Titre"
                                                value={service.title}
                                                onChange={(e) => {
                                                    let o = [...services];
                                                    let m = { ...service };
                                                    m.title = e.target.value
                                                    o[index] = m;
                                                    setServices(o);
                                                    let d = { ...formd };
                                                    d['services'] = o;
                                                    setFrom(d);
                                                }}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md="2" controlId="category">
                                            <Form.Label>Catégorie (requis)</Form.Label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                required
                                                options={[
                                                    { value: 'included', label: 'Inclus' },
                                                    { value: 'not-included', label: 'Non inclus' },
                                                ]}
                                                placeholder='Choisir la categorie...'
                                                classNamePrefix="react-select"
                                                value={service.category}
                                                onChange={value => {
                                                    let o = [...services];
                                                    let m = { ...service };
                                                    m.category = value
                                                    o[index] = m;
                                                    setServices(o);
                                                    let d = { ...formd };
                                                    d['services'] = o;
                                                    setFrom(d);
                                                }}
                                            />

                                        </Form.Group>

                                        <Form.Group as={Col} md="5" controlId="description">
                                            <Form.Label>Description</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={service?.description}
                                                name={`serviceDescription_${index}`}
                                                onChange={(e) => {
                                                    let o = [...services];
                                                    let m = { ...service };
                                                    m.description = e.target.value
                                                    o[index] = m;
                                                    setServices(o);
                                                    let d = { ...formd };
                                                    d['services'] = o;
                                                    setFrom(d);
                                                }}
                                                placeholder="Description du service ..."
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md="4" controlId="descriptionEn">
                                                    <Form.Label>Description Englais</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={service?.descriptionEn}
                                                        name={`serviceDescriptionEn_${index}`}
                                                        onChange={(e) => {
                                                            let o = [...services];
                                                            let m = { ...service };
                                                            m.descriptionEn = e.target.value
                                                            o[index] = m;
                                                            setServices(o);
                                                            let d = { ...formd };
                                                            d['services'] = o;
                                                            setFrom(d);
                                                        }}
                                                        placeholder="Description du service (englais)..."
                                                    />
                                                </Form.Group>


                                        <IconButton as={Col} md="1" onClick={() => {
                                            let arr = services;
                                            arr.splice(index, 1);
                                            setServices(arr);
                                            let d = { ...formd };
                                            d['services'] = arr;
                                            setFrom(d);
                                        }}
                                            variant="falcon-danger"
                                            size="sm"
                                            icon="trash"
                                            transform="shrink-3"
                                            className='me-2'
                                            style={{ width: 60, height: 25, marginTop: 35 }}
                                        >
                                        </IconButton>
                                    </Row>)
                                })
                            }

                            <div>
                                <Flex
                                    alignItems="center"
                                    className="mb-4 text-primary cursor-pointer fs-0"
                                    onClick={() => {
                                        let o = [...services];
                                        if (o[o.length - 1]?.title?.trim() !== "" && o[o.length - 1]?.description?.trim() !== "") {
                                            o.push({ service: null, title: "", description: "", category: null, descriptionEn: "" });
                                            setServices(o);
                                        }
                                    }}
                                >
                                    <span className="circle-dashed">
                                        <FontAwesomeIcon icon="plus" />
                                    </span>
                                    <span className="ms-3">Ajouter un nouveau service</span>
                                </Flex>
                            </div>

                            {services[services.length - 1]?.service === null && (
                                <Form.Text className="text-warning fs--1">
                                    <p>pas dans la liste, <a target="_blank" href="/service/new">Ajouté</a> <IconButton
                                        variant="falcon-default"
                                        size="sm"
                                        icon="reload"
                                        className="me-1 mb-2 mb-sm-0"
                                        iconClassName="me-1"
                                        onClick={() => { loadList() }}>
                                        recharger la liste des services
                                    </IconButton></p>


                                </Form.Text>
                            )}



                        </Row>



                        <hr style={{ marginTop: 10 }} />

                        <Form.Group as={Col} md="8" controlId="calendarId">
                            <Form.Label>Identifiant calendrier Google</Form.Label>
                            <Form.Control
                                minlength="3"
                                type="text"
                                value={formd.calendarId}
                                name="calendarId"
                                onChange={handleChange}
                                placeholder="Demander l'identifiant au dev..."
                            />
                            <Form.Text className="text-warning fs--1">
                                ⚠️ Modifier cette donnée peut rompre le fonctionnement du site
                            </Form.Text>
                        </Form.Group>

                        <hr style={{ marginTop: 10 }} />

                        <Form.Group as={Col} md="4" controlId="localisation.lat">
                            <Form.Label>Localisation latitude</Form.Label>
                            <Form.Control
                                minlength="3"
                                type="text"
                                value={formd?.lat}
                                name="lat"
                                onChange={handleChange}
                                placeholder="Latitude du bien..."
                            />
                            <Form.Text className="text-primary fs--1">
                                informations utilisées pour afficher la propriété sur une carte pour les partenaires
                            </Form.Text>
                        </Form.Group>

                        <Form.Group as={Col} md="4" controlId="localisation.long">
                            <Form.Label>Localisation longitude</Form.Label>
                            <Form.Control
                                minlength="3"
                                type="text"
                                value={formd?.long}
                                name="long"
                                onChange={handleChange}
                                placeholder="Longitude du bien..."
                            />
                            <Form.Text className="text-primary fs--1">
                                Utiliser ce site pour récupéré la latitude et longitude du bien <a href='https://www.latlong.net' target='_blank'>https://www.latlong.net</a>
                            </Form.Text>
                        </Form.Group>

                        <hr className="mt-3" />
                        <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>

                            <Form.Control as="textarea" name="description"
                                placeholder="Laisser une description ici"
                                style={{ height: '100px' }}
                                value={formd.description}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Description (Anglais)</Form.Label>

                            <Form.Control as="textarea" name="description_en"
                                placeholder="Leave a description here..."
                                style={{ height: '100px' }}
                                value={formd.description_en}
                                onChange={handleChange}
                            />
                        </Form.Group>


                        <hr className="mt-3" />
                        <Form.Group className="mb-3">
                            <Form.Label>Détails des pièces</Form.Label>
                            <Form.Control as="textarea" name="description"
                                placeholder="Nécessaire pour le contrat de location"
                                style={{ height: '100px' }}
                                value={formd.detailpiece}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <hr className="mt-3" />
                        <Form.Group className="mb-3">
                            <Form.Label>Commentaire</Form.Label>

                            <Form.Control as="textarea" name="comment"
                                placeholder="Laisser un commentaire ici (interne)"
                                style={{ height: '100px' }}
                                value={formd.comment}
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <hr />

                        {/* <Form.Group as={Col} md="10" controlId="otaId">
                    <Form.Label>Identifiants OTA</Form.Label>
                    <Select
                        closeMenuOnSelect={false} 
                        isMulti
                        options={[
                            {value: "67E36287euue", label: "demo | Airbnb - Alma"}, 
                            {value: "fbeiz dez", label: "demo | Booking - Alma"}, 
                            {value: "fbeiz efzf", label: "demo | Abritel - Alma"},
                            {value: "fbeefz", label: "demo | Airbnb - Vallée du golf"}, 
                            {value: "fbeizdez", label: "demo | Booking - Vallée du golf"}, 
                            {value: "fbeizefzf", label: "demo | Abritel - Vallée du golf"}
                        ]} 
                        placeholder='Choisir les connexions ota...' 
                        classNamePrefix="react-select"
                        value={valueOTA} 
                        onChange={value => {
                            setValueOTA(value)
                            let d = formd;
                            d['otaIds'] = value;
                            setFrom(d);
                        
                        }}
                    />

                    <Form.Text className="text-warning fs--1">
                    Informations utilisées pour se lié aux OTA (pas dans la liste, contacter le dev)
                    </Form.Text>
                </Form.Group>  */}

                        <Form.Group as={Col} md="10" controlId="equipment">
                            <Form.Label>Equipement</Form.Label>
                            <Select
                                closeMenuOnSelect={false}
                                required
                                isMulti
                                options={equipements}
                                placeholder='Choisir les équipements ...'
                                classNamePrefix="react-select"
                                value={valueEquipment}
                                onChange={value => {
                                    setValueEquipment(value)
                                    let d = formd;
                                    d['equipments'] = value;
                                    setFrom(d);
                                }}
                            />

                            <Form.Text className="text-warning fs--1">
                                <p>pas dans la liste, <a target="_blank" href="/equiment/new">Ajouté</a> <IconButton
                                    variant="falcon-default"
                                    size="sm"
                                    icon="reload"
                                    className="me-1 mb-2 mb-sm-0"
                                    iconClassName="me-1"
                                    onClick={() => { loadList() }}>
                                    recharger la liste d'equipement
                                </IconButton></p>


                            </Form.Text>
                        </Form.Group>

                        <Form.Group as={Col} md="10" controlId="contactsId">
                            <Form.Label>Contacts</Form.Label>
                            <Select
                                closeMenuOnSelect={false}
                                isMulti
                                options={clients}
                                placeholder='Choisir les contacts ...'
                                classNamePrefix="react-select"
                                value={valueContacts}
                                onChange={value => {
                                    setValueContactsId(value)
                                    let d = formd;
                                    d['contactsId'] = value;
                                    setFrom(d);
                                }}
                            />

                        </Form.Group>
                        <Form.Text className="text-primary fs--1">
                            Liste du CRM (pas dans la liste, ajouté votre contact dans le CRM puis assigné le ici)
                        </Form.Text>
                    </Row>


                    <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Ajouter'}</Button>

                    <Form.Group as={Col} md="10" controlId="contactsId">
                        <Form.Text className="text-primay fs--1">
                            <br />
                            L'ajout de photos, fichiers ne peut se faire qu'après création de la propriété
                        </Form.Text>
                    </Form.Group>
                </Form>
            </FalconComponentCard.Body>
        </FalconComponentCard>);
};

export default NewVilla;
